import { ReactNode, useState } from 'react';

import {
  TAB_OPTIONS,
  TAB_TEACHING_ANSWERS,
  TAB_TEACHING_NOTES,
} from 'approot/activity-builder/components/teaching-notes/teaching-notes-question-edit.constants';
import Tabs from 'approot/shared/tabs/tabs';
import { TabsWrapper } from 'approot/shared/tabs/tabs.style';
import { ActivityBuilderDrawerContent } from 'approot/activity-builder/activity-builder-drawer.style';

export const TeachingNotesTabs = ({
  teachingNotes,
  suggestedAnswers,
}: {
  teachingNotes: ReactNode;
  suggestedAnswers: ReactNode;
}) => {
  const [tab, setTab] = useState<string>(TAB_TEACHING_NOTES);

  return (
    <>
      <TabsWrapper>
        <Tabs
          ariaDescription="teaching notes tabs"
          contentPanelId="content"
          activeTab={tab}
          onSelect={tab => setTab(tab.value as string)}
          options={TAB_OPTIONS}
        />
      </TabsWrapper>
      <ActivityBuilderDrawerContent id="content">
        {tab === TAB_TEACHING_ANSWERS && suggestedAnswers}
        {tab === TAB_TEACHING_NOTES && teachingNotes}
      </ActivityBuilderDrawerContent>
    </>
  );
};
